/**
 * Pure currency formatting functions for RupeeCell.
 * Accept config explicitly so they can be unit-tested without mocking AuthenticationService.
 */

/**
 * Format a numeric value (in major-unit.minor-unit form, e.g. rupees.paise)
 * using the given operator currency config.
 *
 * @param {number|string} value  — float like "1234.56" or raw paise-level double
 * @param {object} config        — getCurrencyConfig() result (may be null/undefined)
 */
export function formatCurrency(value, config) {
  const cfg       = config || {};
  const symbol    = cfg.currencySymbol != null ? cfg.currencySymbol : "₹"; // ₹
  const decSep    = cfg.decimalSeparator    || ".";
  const grpSep    = cfg.groupingSeparator   || ",";
  const grpStyle  = cfg.groupingStyle       || "INDIAN";

  const num = parseFloat(value);
  if (isNaN(num)) return value != null ? String(value) : "";

  // Single-rounding split avoids carry bug (e.g. 2.999 → "2.100" with floor+round)
  const totalMinor = Math.round(Math.abs(num) * 100);
  const major      = Math.floor(totalMinor / 100);
  const minor      = totalMinor % 100;
  const fracStr    = minor < 10 ? "0" + minor : String(minor);
  const prefix     = num < 0 ? "-" : "";

  return prefix + symbol + formatInteger(major, grpStyle, grpSep) + decSep + fracStr;
}

/**
 * Apply grouping separators to an integer.
 * INDIAN: rightmost group of 3, then groups of 2 leftward.
 * WESTERN: groups of 3 from right.
 */
export function formatInteger(n, groupingStyle, sep) {
  const raw = String(Math.floor(n));
  if (raw.length <= 3) return raw;

  if (groupingStyle === "WESTERN") {
    return raw.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  // INDIAN: last 3 digits, then groups of 2
  const lastThree = raw.slice(-3);
  const remaining = raw.slice(0, -3);
  if (!remaining) return lastThree;
  return remaining.replace(/\B(?=(\d{2})+(?!\d))/g, sep) + sep + lastThree;
}
